
  import { computed, defineComponent } from 'vue';
  import { Breakpoint } from '../../../helpers/breakpoint';
  import TpxList from './list.vue';
  import './inline-list.scss';

  /**
   * Inline list
   *
   * @extends TpxList
   * 
   * @example
   * <code>import TpxInlineList from '@manifesto-tech/tpximpact-design-system/components/atoms/list/inline-list.vue'</code>
   */
  export default defineComponent({
    name: 'TpxInlineList',
    extends: TpxList,
    
    components: {
      TpxList,
    },

    props: {
      /**
       * Specify the breakpoint at which the inline list styling gets applied
       */
      breakpoint: {
        type: String,
        validator: (value: Breakpoint) => {
            return Object.values(Breakpoint).includes(value);
        },
      },

      /**
       * Separate items with a bull?
       */
      includeSeparator: {
        type: Boolean,
      },

      /**
       * Include additional space between each item when inline?
       */
      includeSpaceBetween: {
        type: Boolean,
      },
    },

    data() {
      return {
        classes: computed(() => ({
          ['a-list--inline']: !this.breakpoint,
          ['a-list--inline@medium']: this.breakpoint == Breakpoint.Medium,
          ['a-list--inline@large']: this.breakpoint == Breakpoint.Large,
          ['a-list--inline--include-separator']: this.includeSeparator,
          ['a-list--inline--include-space-between']: this.includeSpaceBetween,
        })),
      }
    }
  });
